// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"2178":"SimpleHeader","4292":"TitleHeader","5554":"BannerHeader","7573":"LocationHeader","8494":"DashboardHeader","8672":"HomepageHeader"}[chunkId] || chunkId) + ".css";
};